import { useQuery } from '@tanstack/react-query';
import { systemApi } from '../services/api';

/**
 * Shows the deployed frontend version (baked in at build time) and the live API version (fetched
 * from /api/system/version). Both carry the commit count as their patch number, so after a deploy
 * you can confirm at a glance that your build reached the server. The exact commit ids stay in the
 * tooltip, where they are available when a version alone is not specific enough.
 */
export default function VersionInfo() {
  const { data: apiVersion } = useQuery({
    queryKey: ['apiVersion'],
    queryFn: systemApi.getVersion,
    staleTime: 60 * 1000,
    retry: false,
  });

  const tooltip = [
    `app ${__APP_VERSION__} (${__APP_COMMIT__})`,
    apiVersion ? `api ${apiVersion.version} (${apiVersion.commit})` : null,
    apiVersion?.buildTime ? `api built ${apiVersion.buildTime}` : null,
  ]
    .filter(Boolean)
    .join('\n');

  return (
    <p className="text-xs text-gray-400 dark:text-gray-600" title={tooltip}>
      app {__APP_VERSION__} · api {apiVersion?.version ?? '…'}
    </p>
  );
}
